export type DeviceErrorCode =
  | "DISCONNECTED"
  | "CONNECTING_ERROR"
  | "TIMEOUT"
  | "UNLOCK_REQUIRED"
  | "DIFFERENT_WALLET"
  | "USER_TERMINATED"
  | "MEDIUM_BUSY"
  | "FAILED_FETCH_PUBKEY"
  | "FAILED_FETCH_WALLET_ID"
  | "FAILED_OPEN_APP"
  | "FAILED_SIGN_TX"
  | "UPDATE_SIGN_TX"
  | "NOT_SUPPORTED"
  | "RPC_DOWN"
  | "UNKNOWN";

export class DeviceError extends Error {
  constructor(
    public readonly code: DeviceErrorCode,
    message: string,
  ) {
    super(message);
    this.name = "DeviceError";
  }
}

const ERROR_MAP: Record<number, { code: DeviceErrorCode; message: string }> = {
  1:    { code: "DISCONNECTED",           message: "Device has disconnected." },
  2:    { code: "CONNECTING_ERROR",       message: "Error connecting to the device." },
  3:    { code: "TIMEOUT",               message: "Device timeout occurred." },
  4:    { code: "UNLOCK_REQUIRED",        message: "Unlock the device to proceed." },
  9:    { code: "DIFFERENT_WALLET",       message: "Connected device belongs to a different wallet." },
  10:   { code: "USER_TERMINATED",        message: "User terminated the operation." },
  18:   { code: "MEDIUM_BUSY",            message: "Device is busy, please try again later." },
  300:  { code: "FAILED_FETCH_PUBKEY",    message: "Failed to fetch the public key." },
  301:  { code: "FAILED_FETCH_WALLET_ID", message: "Failed to fetch wallet ID." },
  302:  { code: "FAILED_OPEN_APP",        message: "Failed to open app." },
  303:  { code: "FAILED_SIGN_TX",         message: "Failed to sign the transaction." },
  304:  { code: "FAILED_SIGN_TX",         message: "Failed to sign the transaction." },
  307:  { code: "UPDATE_SIGN_TX",         message: "Transaction signing requires an update." },
  309:  { code: "NOT_SUPPORTED",          message: "Feature not supported on this device." },
  3082: { code: "RPC_DOWN",              message: "All RPC nodes are currently down." },
};

export function deviceErrorFromCode(errorCode: number): DeviceError {
  const entry = ERROR_MAP[errorCode] ?? {
    code: "UNKNOWN" as DeviceErrorCode,
    message: "An unknown error occurred.",
  };
  return new DeviceError(entry.code, entry.message);
}
